<template>
  <header class="performance-card__header insights-tooltip" :data-tooltip="tooltip">{{title}}</header>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    tooltip: {
      type: String
    }
  }
}
</script>

<style scoped>
  .performance-card__header {
    font-weight: bold;
    font-size: 18px;
    line-height: 140%;
    text-align: left;
  }
</style>
